import { Box, Divider, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Scrollbars from "react-custom-scrollbars-2";
import { TradeLogsRow } from "./TradeLogsRow";
import { useSignalRContext } from "../../../SignalR/useSignalR";

export const TradeLogs = ()=>{

    const { tradeLogsList } = useSignalRContext();
    const columns= [
        // "Date/Time",
        // "Index",
        "Time",
        "Type",
        "Message Type",
        "Message",        
    ];

    return (
        <>
            <Box padding={0} sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <TableContainer component={Paper} sx={{
                boxShadow: "none",
                maxHeight: "calc(100vh - 350px)",
                overflow: "hidden",
                margin: '0 !important',
                padding: '0 !important',
                flex: 1
            }}>
                <Scrollbars className="custom-scroll" autoHeight autoHeightMax="100%">
                    <Table
                        sx={{
                            marginTop: '0 !important',
                            borderSpacing: "0px 0px",
                            borderCollapse: "separate",
                            '& .MuiTableCell-root': {
                                padding: '4px 8px',
                                fontSize: '11px',
                                height: 24,
                                borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
                            },
                            '& .MuiTableHead-root .MuiTableCell-root': {
                                backgroundColor: 'rgba(6, 182, 212, 0.12)',
                                fontWeight: 600,
                                fontSize: '11px',
                                height: 26,
                                color: '#06b6d4',
                                padding: '4px 8px',
                            },
                            '& .MuiTableRow-root': {
                                height: 24,
                            },
                        }}>
                        <TableHead>
                            <TableRow
                                sx={{
                                    "& .MuiTableCell-root": {
                                    padding: "0px 10px",
                                    borderBottom: "none",
                                  },
                                }}
                            >
                                {columns.map((header)=>{
                                    return(
                                    <TableCell>
                                        <Typography color="text.tableheader">
                                            {header}
                                        </Typography>
                                    </TableCell>
                                    )
                                })}

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(tradeLogsList && tradeLogsList.length > 0) ? (
                                tradeLogsList
                                .slice()
                                .reverse()
                                .slice(0, 100) // Limit to latest 100 logs
                                .map((data, index)=>{
                                    if(data){                                        
                                        return (                                        
                                        <TradeLogsRow key={`trade-log-${index}-${data.time || Date.now()}`} data={data} />
                                        );
                                    }
                                    return null;
                                })
                            ) : (
                            <TableRow
                            sx={{
                                "& .MuiTableCell-root": {
                                padding: "0px 10px",
                                borderBottom: "none",
                                },
                            }}>
                                <TableCell colSpan={13}>
                                    <Box display="flex" justifyContent="center">
                                        <Typography>No Logs!!</Typography>
                                    </Box>
                                </TableCell>
                            </TableRow>
                                )  
                            }
                        </TableBody>
                    </Table>
                </Scrollbars>
            </TableContainer>
        </Box>    
        </>
    );
}